import isEmpty from 'lodash/isEmpty'
import React from 'react'

import { CollaboratorsWidget } from './Widget'
import type { Customer, FilterQuery, User, Vendor } from '@ztechapps/common.contract'
import type { SelectAsyncProps, SelectCreatableOption, SelectOption } from '../Select'
import { SelectAsync } from '../Select/SelectAsync'
import { ShowIf } from '@ztechapps/webui.util'
import { useCollaborators, useError } from '@ztechapps/common.hook'
import { UserMenuList, UserOptionSimple } from '../User/UserSelect/UserSelect'
import type { SelectAsyncCreatable } from '../Select/SelectAsyncCreatable'
import get from 'lodash/get'
import { isValidEmail } from '@ztechapps/common.utils'

export type Collaborator = Vendor & Customer & User
export type CollaboratorSelectOption = SelectOption<Collaborator>
export type CollaboratorSelectCreatableOption = SelectCreatableOption<Collaborator>

export type BaseCollaboratorSelectProps = {
  filter?: FilterQuery<Collaborator>
  value: CollaboratorSelectOption
  showInfo?: boolean
  As?: typeof SelectAsyncCreatable | typeof SelectAsync
}

export type CollaboratorSelectProps = BaseCollaboratorSelectProps & SelectAsyncProps<CollaboratorSelectOption>

export const CollaboratorSelect = ({ filter, showInfo = false, onChange, As, ...rest }: CollaboratorSelectProps) => {
  const { onError } = useError()
  const { dataLoadOptions } = useCollaborators()

  As = As || SelectAsync

  return (
    <React.Fragment>
      <As
        {...{
          components: { Option: UserOptionSimple, MenuList: UserMenuList },
          placeholder: 'Type company or email or name.',
          labelKey: 'profile.name',
          noOptionsMessage: () => 'Cannot find any users.',
          dataLoadOptions: dataLoadOptions({ filter }),
          getNewOptionData: (inputValue, optionLabel) => {
            return {
              value: inputValue,
              label: inputValue,
              profile: {
                name: optionLabel,
                email: optionLabel,
              },
              _id: inputValue,
              __isCreate: true,
            }
          },
          formatCreateLabel: (inputValue) => {
            return `Press TAB to create collaborator "${inputValue} (make sure it is valid email format)"`
          },
          onChange: (newValue, actionMeta) => {
            const operate = (value: SelectCreatableOption) => {
              //can't we get it from action meta
              if (value?.__isCreate) {
                const email = get(value, 'profile.email')
                if (!isValidEmail(email)) {
                  onError(`${email} is not a valid email address for this collaborator.`)
                }
              }
            }

            //we need to consider if hte
            if (rest.isMulti) {
              newValue.forEach((m) => operate(m))
            } else {
              operate(newValue as SelectCreatableOption)
            }

            onChange(newValue, actionMeta)
          },

          ...rest,
        }}
      />
      <ShowIf condition={showInfo && !isEmpty(rest.value?._id)}>
        <div className={'mt-3'}>
          <CollaboratorsWidget {...rest?.value} />
        </div>
      </ShowIf>
    </React.Fragment>
  )
}
